import React from 'react';
import { classnames } from '../../../utils';
import Tooltip from '../Tooltip';
import styles from './Hint.module.scss';

type Props = {
  size?: 'small' | 'large';
  text: React.ReactNode;
  type?: 'hint' | 'info' | 'infobold';
  html?: boolean;
};

export default function Hint({ text, type = 'hint', size = 'small', html = true }: Props) {
  return (
    <Tooltip content={text} html={html}>
      <span className={classnames([styles.wrapper, styles[type], styles[size]])}></span>
    </Tooltip>
  );
}
